import { getDateByDateTimeValue } from '@elfsight/lib-utils';
import type {
  RepeatFrequencyValue,
  ScheduleDefaultsType
} from '@elfsight/widget-conditional-display';
import { DAY_MAP } from './constants';

export const buildCustomRRule = (
  {
    scheduleRepeatFrequency,
    scheduleRepeatInterval,
    scheduleRepeatWeeklyOnDays,
    scheduleRepeatMonthlyOnDay,
    scheduleRepeatEnds,
    scheduleRepeatEndsDate,
    scheduleRepeatEndsOccurrences
  }: ScheduleDefaultsType,
  start: Date
) => {
  const frequencyMap: Record<RepeatFrequencyValue, string> = {
    daily: 'DAILY',
    weeklyOn: 'WEEKLY',
    monthly: 'MONTHLY',
    annuallyOn: 'YEARLY'
  };
  const frequency = frequencyMap[scheduleRepeatFrequency];
  const parts = [`FREQ=${frequency}`];

  if (scheduleRepeatInterval > 1) {
    parts.push(`INTERVAL=${scheduleRepeatInterval}`);
  }

  if (
    scheduleRepeatFrequency === 'weeklyOn' &&
    scheduleRepeatWeeklyOnDays.length
  ) {
    parts.push(
      `BYDAY=${scheduleRepeatWeeklyOnDays.map((day) => DAY_MAP[day]).join(',')}`
    );
  }

  if (scheduleRepeatFrequency === 'monthly') {
    if (scheduleRepeatMonthlyOnDay === 'sameDayInMonth') {
      parts.push(`BYMONTHDAY=${start.getDate()}`);
    }

    if (scheduleRepeatMonthlyOnDay === 'lastDayInMonth') {
      parts.push('BYMONTHDAY=-1');
    }

    if (scheduleRepeatMonthlyOnDay === 'nthDayInMonth') {
      const weekOfMonth = Math.floor((start.getDate() - 1) / 7) + 1;
      parts.push(`BYDAY=${weekOfMonth}${DAY_MAP[start.getDay()]}`);
    }
  }

  if (scheduleRepeatEnds === 'onDate' && scheduleRepeatEndsDate) {
    const until = getDateByDateTimeValue(scheduleRepeatEndsDate);
    const iso = `${until.toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;
    parts.push(`UNTIL=${iso}`);
  }

  if (
    scheduleRepeatEnds === 'afterOccurrences' &&
    scheduleRepeatEndsOccurrences
  ) {
    parts.push(`COUNT=${scheduleRepeatEndsOccurrences}`);
  }

  return parts;
};
